import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SignatureIcon from '../../../assets/icons/signature.svg';
import InitialsIcon from '../../../assets/icons/initials.svg';
import { useColumnOrder } from '../../../hooks/useColumnOrder';

const Icon = styled.img`
  margin: 0;
  padding: 0;
  margin-right: ${({ noPadding }) => (noPadding ? '0' : '10px')};
`;

const OuterContainer = styled.div`
  position: absolute;
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  margin: 0;
  padding: 0;
  pointer-events: auto;
`;

const SignatureField = styled.div`
  font-size: ${({ fontSize }) => fontSize + 'px'};
  display: flex;
  align-items: center;
  gap: 0;
  border: 1px solid #c5c7d0 !important;
  border-radius: 4px !important;
  width: 100%;
  height: 100%;
  background: ${({ backgroundColor }) => backgroundColor};
  color: black;
  padding-left: ${({ noPadding }) => (noPadding ? '0' : '8px')};
  padding-right: ${({ noPadding }) => (noPadding ? '0' : '8px')};
  line-height: ${({ fontSize }) => fontSize + 'px'};
  & * {
    margin: 0;
    padding: 0;
  }

  div {
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    padding: 0;
  }
`;

const SignatureAndInitialsPreviewChip = ({ x, y, item, from, showColor }) => {
  const { mapColor } = useColumnOrder();
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor ? mapColor(itemColor) : '#E6E6FA';
  const { t } = useTranslation();
  const borderWidth = 4;
  const defaultHeight = 26.66;
  const defaultWidth = 183.33;
  const defaultFontSize = 11;
  const noPadding = item.noPadding || false;
  const padding = noPadding ? 0 : 6;

  return (
    <OuterContainer
      x={x + padding + borderWidth}
      y={y + padding + borderWidth}
      width={item.width || defaultWidth}
      height={item.height || defaultHeight}
      fontSize={item.fontSize || defaultFontSize}
    >
      <SignatureField
        backgroundColor={backgroundColor}
        fontSize={item.fontSize || 11}
        noPadding={noPadding}
      >
        <div>
          {item?.title.includes('Signature') && (
            <Icon
              src={SignatureIcon}
              alt=""
              height={16}
              width={16}
              noPadding={noPadding}
            />
          )}
          {item?.title.includes('Initials') && (
            <Icon
              src={InitialsIcon}
              alt=""
              height={16}
              width={16}
              noPadding={noPadding}
            />
          )}
          {showColor && item?.signer?.label
            ? item.signer.label
            : item?.title.includes('Signature')
            ? t('Signature')
            : t('Initials')}
        </div>
      </SignatureField>
    </OuterContainer>
  );
};

export default SignatureAndInitialsPreviewChip;
